import settings from "../Settings.js";
export default {
  log: function () {
    if (settings.develop) {
      console.log(...arguments);
    }
  },
  table: function () {
    if (settings.develop) {
      console.table(...arguments);
    }
  },
  info: function () {
    if (settings.develop) {
      console.info(...arguments);
    }
  },
  error: function () {
    if (settings.develop) {
      console.error(...arguments);
    }
  },
};
